import jwtDecode from "jwt-decode";
import { JWTData } from "../types";

export default (token: string): JWTData => {
	return jwtDecode<JWTData>(token);
};
